"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMacroOpcodeTemplates = getMacroOpcodeTemplates;
function getMacroOpcodeTemplates() {
    return `
                        // Macro Operations (fused instructions)

                        case opMap[250]: { // MACRO_INC_LOCAL: local[arg]++
                            // Fuses: LOAD_LOCAL, PUSH_CONST 1, ADD, STORE_LOCAL
                            locals[arg] = locals[arg] + 1;
                            pc++;
                            break;
                        }

                        case opMap[251]: { // MACRO_DEC_LOCAL: local[arg]--
                            // Fuses: LOAD_LOCAL, PUSH_CONST 1, SUB, STORE_LOCAL
                            locals[arg] = locals[arg] - 1;
                            pc++;
                            break;
                        }

                        case opMap[252]: { // MACRO_ADD_LOCAL_CONST: push(local[localIdx] + const[constIdx])
                            // Fuses: LOAD_LOCAL, PUSH_CONST, ADD
                            // arg = (constIdx << 16) | localIdx
                            let macroLocalIdx = arg & 0xFFFF;
                            let macroConstIdx = arg >>> 16;
                            stack.push(locals[macroLocalIdx] + constants[macroConstIdx]);
                            pc++;
                            break;
                        }

                        case opMap[253]: { // MACRO_SUB_LOCAL_CONST: push(local[localIdx] - const[constIdx])
                            // Fuses: LOAD_LOCAL, PUSH_CONST, SUB
                            // arg = (constIdx << 16) | localIdx
                            let macroLocalIdx = arg & 0xFFFF;
                            let macroConstIdx = arg >>> 16;
                            stack.push(locals[macroLocalIdx] - constants[macroConstIdx]);
                            pc++;
                            break;
                        }

                        case opMap[254]: { // MACRO_MUL_LOCAL_CONST: push(local[localIdx] * const[constIdx])
                            // Fuses: LOAD_LOCAL, PUSH_CONST, MUL
                            // arg = (constIdx << 16) | localIdx
                            let macroLocalIdx = arg & 0xFFFF;
                            let macroConstIdx = arg >>> 16;
                            stack.push(locals[macroLocalIdx] * constants[macroConstIdx]);
                            pc++;
                            break;
                        }

                        case opMap[255]: { // MACRO_LOAD_LOCAL_GET_PROP: push(local[localIdx][const[propIdx]])
                            // Fuses: LOAD_LOCAL, GET_PROP
                            // arg = (propIdx << 16) | localIdx
                            let macroLocalIdx = arg & 0xFFFF;
                            let macroPropIdx = arg >>> 16;
                            let macroObj = locals[macroLocalIdx];
                            let macroProp = constants[macroPropIdx];
                            stack.push(macroObj[macroProp]);
                            pc++;
                            break;
                        }

                        case opMap[256]: { // MACRO_LT_LOCAL_CONST: push(local[localIdx] < const[constIdx])
                            // Fuses: LOAD_LOCAL, PUSH_CONST, LT
                            // arg = (constIdx << 16) | localIdx
                            let macroLocalIdx = arg & 0xFFFF;
                            let macroConstIdx = arg >>> 16;
                            stack.push(locals[macroLocalIdx] < constants[macroConstIdx]);
                            pc++;
                            break;
                        }

                        case opMap[257]: { // MACRO_JUMP_IF_LOCAL_LT_CONST: if (local[localIdx] < const[constIdx]) jump
                            // Fuses: LOAD_LOCAL, PUSH_CONST, LT, JUMP_IF_TRUE
                            // arg = (constIdx << 16) | localIdx, target stored in jump targets
                            let macroLocalIdx = arg & 0xFFFF;
                            let macroConstIdx = arg >>> 16;
                            if (locals[macroLocalIdx] < constants[macroConstIdx]) {
                                pc = decodeJump(jumpTargets[pc]);
                            } else {
                                pc++;
                            }
                            break;
                        }

                        case opMap[258]: { // MACRO_CALL_LOCAL_METHOD: local[localIdx][const[propIdx]](...args)
                            // Fuses: LOAD_LOCAL, GET_PROP, CALL_METHOD
                            // arg = (propIdx << 16) | localIdx
                            let macroLocalIdx = arg & 0xFFFF;
                            let macroPropIdx = arg >>> 16;
                            let macroArgCount = stack.pop();
                            let macroCallArgs = collectArgs(stack, macroArgCount);
                            let macroCallObj = locals[macroLocalIdx];
                            let macroCallProp = constants[macroPropIdx];
                            let macroCallMethod = macroCallObj[macroCallProp];
                            stack.push(macroCallMethod.apply(macroCallObj, macroCallArgs));
                            pc++;
                            break;
                        }

                        case opMap[259]: { // MACRO_STORE_LOCAL_POP: store and discard
                            // Fuses: STORE_LOCAL, POP
                            locals[arg] = stack.pop();
                            pc++;
                            break;
                        }

                        case opMap[260]: { // MACRO_INC_LOCAL_PRE: ++local[arg] (returns incremented value)
                            // Fuses: LOAD_LOCAL, PUSH_CONST 1, ADD, DUP, STORE_LOCAL
                            let macroIncVal = locals[arg] + 1;
                            locals[arg] = macroIncVal;
                            stack.push(macroIncVal);
                            pc++;
                            break;
                        }

                        case opMap[261]: { // MACRO_DEC_LOCAL_PRE: --local[arg] (returns decremented value)
                            // Fuses: LOAD_LOCAL, PUSH_CONST 1, SUB, DUP, STORE_LOCAL
                            let macroDecVal = locals[arg] - 1;
                            locals[arg] = macroDecVal;
                            stack.push(macroDecVal);
                            pc++;
                            break;
                        }
    `;
}
